// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__nqE7Y","heading":"styles_heading__+BrmK"};